export const GRAIN_CONVEYORS = 'En-Masse Conveyors'
export const BUCKET_ELEVATORS = 'Bucket Elevators'
export const INCLINE_CONVEYORS = 'Incline Conveyors'
export const GRAIN_AUGERS = 'Grain Augers'
export const ATTRIBUTE_NAMES = {
  'pa_height': 'Height',
  'pa_model-number': 'Model No.',
  'pa_hp': 'HP',
  'pa_drive-size': 'Drive Size',
  'pa_length': 'Length',
  'pa_hole': 'Hole',
  'pa_size': 'Size',
  'pa_series': 'Series',
  'pa_section': 'Section',
}
export const PRICE_ON_REQUEST = 'Price on request. Contact Farm Equipment Plus for a custom quote.';